/* global $ */
import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { Slider } from 'react-slick';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { modal } from 'react-redux-modal';

import { isArrayEqual } from '../../utils';

import { setCurrentItem, livecamClickTracker } from '../../actions/currentItem';
import { fetchRelatedSnapshotFeed } from '../../actions/relatedSnapshots';
import { showRelatedSnapshots } from '../../actions/uiPreferences';
import { setCamGroupInfo } from '../../actions/camgroups';
import { camGroupCarouselSlickSettings } from '../../constants/slick';
import { CamGroupInfoModalView } from '../../components';

import './styles.scss';
import TrackedButton from '../Buttons/TrackedButton';

export class DesktopCamGroupCarousel extends React.Component {

  constructor(props) {
    super(props);
    this.setCurrentItem = this.setCurrentItem.bind(this);
    this.navigate = this.navigate.bind(this);
    this.showInfo = this.showInfo.bind(this);
    this.updateCamGroupCarousel = this.updateCamGroupCarousel.bind(this);

    this.state = {
      slides: [],
    };
  }

  componentWillMount() {
    const { slides } = this.props;
    this.setStartingSlide();
    this.setState({ slides });
  }

  componentWillReceiveProps(nextProps) {
    const { slides } = nextProps;
    this.setState({ slides });
  }

  shouldComponentUpdate(nextProps) {
    for (const property in nextProps) {
      if (nextProps[property] !== this.props[property]) {
        if (property !== 'navChannelId') return true;
        if (nextProps.navChannelId !== '') {
          this.updateCamGroupCarousel(parseInt(nextProps.navChannelId, 10), true);
        }
      }
    }
    if (!isArrayEqual(this.props.slides, nextProps.slides)) return true;
    return false;
  }

  componentWillUpdate(nextProps) {
    const { toggleShowRelatedSnapshotsAction } = this.props;
    this.updateCamGroupCarousel(parseInt(nextProps.navChannelId, 10));

    if (!this.props.showRelatedSnapshots) toggleShowRelatedSnapshotsAction();
  }

  setStartingSlide() {
    const { activeCamGroupId, camGroups } = this.props;
    const activeCamgroups = camGroups.filter((camGroup) => {
      if (camGroup.feed_count && camGroup.feed_count > 0) {
        return true;
      }
      return false;
    });
    // If we're on a specific cam, we want to set that item as the first.
    const activeCamGroup = activeCamgroups.find((group) => {
      return group.id === activeCamGroupId;
    });
    if (activeCamGroup) {
      camGroupCarouselSlickSettings.initialSlide = `.cam-group-item.channel-poster[data-cam-group-id="${activeCamGroup.id}"]`;
    }
  }

  setCurrentItem(id, state, feedId) {
    return (e) => {
      const { fetchRelatedSnapshotFeedAction, setCurrentItemAction } = this.props;
      e.preventDefault();
      const $this = $(e.target).closest('a');
      if ($this.find('[data-headline]').hasClass('active') ||
          $(e.target).hasClass('info-btn')) {
        return;
      }
/*
      fetchRelatedSnapshotFeedAction(id, true);
      setCurrentItemAction(id, state, feedId);
*/
      //
      this.props.incrementLivecamTracker();
      const $navGroup = $('.nav-group');
      if ($navGroup.hasClass('is-locked')) {
        const combinedNavHeight = ($navGroup.outerHeight() + $('.nav-wrapper').outerHeight());
        $navGroup.css('top', -combinedNavHeight);
        _.delay(() => {
          $navGroup.removeClass('is-locked');
          $('body').css('margin-top', '0');
        }, 300);
      }

      this.context.router.push($this.attr('href'));
    };
  }

  navigate(direction) {
    return () => {
      const slider = this.camGroupSlider.innerSlider;
      if (direction === 'previous') {
        slider.slickPrevPage();
      } else if (direction === 'next') {
        slider.slickNextPage();
      }
    };
  }

  showInfo(camgroup) {
    const { setCamGroupInfoAction } = this.props;

    let fullDesc = `${camgroup.description || ''} ${camgroup.continuedDescription || ''}`.trim();
    if (fullDesc === '') {
      fullDesc = 'This is under Tender Love and Construction.';
    }

    const data = {
      fullDesc,
      camGroupPoster: camgroup.imageUrl,
      url: camgroup.url,
      title: camgroup.title,
    };

    setCamGroupInfoAction(data);

    modal.add(CamGroupInfoModalView, {
      title: '',
      size: 'medium',
      hideTitleBar: true,
      id: 'signup',
    });
  }

  updateCamGroupCarousel(index, isExternalClick) {
    if (!isExternalClick) return;
    const slideIndexSelector = `.cam-group-item.channel-poster[data-channel-id="${index}"][data-initial-channel-camgroup="true"]`;
    this.camGroupSlider.slickGoTo(slideIndexSelector);
  }

  render() {
    const { camGroups, activeCamGroupId, activeFeedId } = this.props;
    const { slides } = this.state;

    if (this.state.slides.length === 0) {
      return null;
    }
    const currentItem = this.setCurrentItem;
    return (
      <div>
        <div className="nav-group main-cam-carousel">
          <div id="channel-nav-wrapper" className="container-fluid" data-scroll>
            <div className="row cam-groups">
              <div className="col-sm-12 p-0">
                <a
                  className="cam-group-arrow arrows left"
                  role="button"
                  onClick={this.navigate('previous')}
                  tabIndex={0}
                >
                  <i className="icon-PosterArrowLeft" />
                </a>
                {slides.length > 0 ?
                  <Slider
                    {...camGroupCarouselSlickSettings}
                    ref={(slider) => {
                      this.camGroupSlider = slider;
                    }}
                    className="cam-group-carousel"
                  >
                    {slides.map((camgroup, index) => {
                      const uniqueKey = index;
                      const isActive = activeCamGroupId === camgroup.camgroupId;
                      const isActiveClass = (isActive) ? 'active' : '';
                      return (
                        <Link
                          to={camgroup.url}
                          key={uniqueKey}
                          className="cam-group-item channel-poster"
                          onClick={currentItem(camgroup.camgroupId, camGroups, camgroup.feedId)}
                          data-cam-group-id={camgroup.camgroupId}
                          data-feed-id={camgroup.feedId}
                          data-channel-id={camgroup.carouselChannelId}
                          data-initial-channel-camgroup={camgroup.isInitialChannelCamgroup}
                        >
                          <div className="cam-group-item-wrapper aspect-2-3">
                            <div className="cam-group-item-overlay">
                              <TrackedButton
                                className="info-btn text-uppercase u-textSize-16"
                                onClick={() => this.showInfo(camgroup)}
                                title="Information"
                                action={`Open camgroup information modal for ${camgroup.title}`}
                              />
                            </div>
                            <div className="cam-group-inner-content">
                              <img
                                src={camgroup.imageUrl ? camgroup.imageUrl.replace('http://', 'https://') : ''}
                                alt={camgroup.title}
                              />
                              <div className="cam-item-overlay">
                                <div data-headline="" className={`${isActiveClass} align-items-center`}>
                                  <div className="inner-overlay-text">
                                    <div className="u-font-foundation-light u-textSize-12">
                                      {camgroup.feedCount}<br />
                                      streams
                                    </div>
                                  </div>
                                </div>

                              </div>
                            </div>
                          </div>

                        </Link>
                      );
                    })}
                  </Slider>
                  : ''}
                <a
                  role="button"
                  className="cam-group-arrow arrows right"
                  onClick={this.navigate('next')}
                  tabIndex={0}
                >
                  <i className="icon-PosterArrowRight" />
                </a>
              </div>
            </div>

          </div>
        </div>

      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    camGroups: state.cam_groups.data || [],
    isFetching: state.cam_groups.isFetching,
    activeFeedId: state.currentItem.data.id,
    showRelatedSnapshots: state.uiPreferences.showRelatedSnapshots,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setCamGroupInfoAction: (data) => {
      dispatch(setCamGroupInfo(data));
    },
    setCurrentItemAction: (id, state, feedId) => {
      dispatch(setCurrentItem(id, state, feedId));
    },
    fetchRelatedSnapshotFeedAction: (camGroupId, reset) => {
      dispatch(fetchRelatedSnapshotFeed(camGroupId, reset));
    },
    toggleShowRelatedSnapshotsAction: () => {
      dispatch(showRelatedSnapshots());
    },
    incrementLivecamTracker: () => {
      dispatch(livecamClickTracker());
    },
  };
};

DesktopCamGroupCarousel.propTypes = {
  camGroups: PropTypes.array,
  isFetching: PropTypes.bool,
  activeCamGroupId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  activeFeedId: PropTypes.number,
  navChannelId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  showRelatedSnapshots: PropTypes.bool,
  setCamGroupInfoAction: PropTypes.func,
  setCurrentItemAction: PropTypes.func,
  fetchRelatedSnapshotFeedAction: PropTypes.func,
  setChannelNavPositionAction: PropTypes.func,
  toggleShowRelatedSnapshotsAction: PropTypes.func,
  incrementLivecamTracker: PropTypes.func,
  slides: PropTypes.array.isRequired,
};

DesktopCamGroupCarousel.contextTypes = {
  router: PropTypes.object,
};

DesktopCamGroupCarousel.defaultProps = {
  camGroups: [],
  isFetching: false,
  activeCamGroupId: null,
  activeFeedId: null,
  navChannelId: null,
  showRelatedSnapshots: true,
  setCamGroupInfoAction: _.noop,
  setCurrentItemAction: _.noop,
  fetchRelatedSnapshotFeedAction: _.noop,
  setChannelNavPositionAction: _.noop,
  toggleShowRelatedSnapshotsAction: _.noop,
  incrementLivecamTracker: _.noop,
};

export default connect(mapStateToProps, mapDispatchToProps)(DesktopCamGroupCarousel);
